import React from "react";
import { Select } from "../Select";
import { useTheme } from "../theme";
import { LinkButton } from "../Button";

export function createFilterFn(selected) {
    const { key, getFilterFn } = selected;

    const defaultFilterFn = (field) => {
        return Array.isArray(field)
            ? field.some((val) => val === key)
            : field === key;
    };
    return getFilterFn ? getFilterFn() : defaultFilterFn;
}

export function createSelectFilter(staticLabel, staticOptions = []) {
    return ({
        label = staticLabel,
        value = "",
        className = "",
        id,
        options = [],
        onChange,
        ...rest
    }) => {
        const { modularScale, altTextColor } = useTheme();
        const labelSize = modularScale(-1);

        const choices = [
            { key: "all", label: "All", getFilterFn: () => null },
        ].concat(staticOptions, options);

        const onSelect = (selectedValue) => {
            const { key, label } = selectedValue;
            onChange({ key, label }, createFilterFn(selectedValue));
        };

        const isDefaultValue =
            value === null ||
            (choices[0].key === value?.key &&
                choices[0].label === value?.label);

        const onReset = () => {
            const defaultValue = choices[0];
            const { key, label } = defaultValue;
            onChange({ key, label }, createFilterFn(defaultValue));
        };

        return (
            <div className={`select-filter ${className}`}>
                <label htmlFor={id} className="select-filter__label-text">
                    {label}
                </label>
                <Select
                    id={id}
                    className="select-filter__select"
                    value={value}
                    options={choices}
                    onSelect={onSelect}
                    {...rest}
                />
                {!isDefaultValue && <LinkButton className="select-filter__reset" onClick={onReset}>
                    Clear
                </LinkButton>}
                <style jsx>{`
                    .select-filter {
                        // Contain floats
                        overflow: auto;
                        display: flex;
                        flex-wrap: wrap;
                    }
                    .select-filter__label-text {
                        display: block;
                        font-size: ${labelSize}em;
                        font-weight: 600;
                        color: ${altTextColor};
                        margin-bottom: 0.5em;
                        flex: 1 1 auto;
                    }
                    .select-filter :global(.select-filter__select) {
                        width: 100%;
                        flex: 1 1 auto;
                        order: 2;
                    }
                    .select-filter :global(.select-filter__reset) {
                        font-size: ${labelSize}em;
                        margin-bottom: 0.5em;
                        float: right;
                        flex: 0 0 auto;
                        margin-left: auto;
                        order: 1;
                    }
                `}</style>
            </div>
        );
    };
}

export const extractFilterOptions = ({ filterData }) =>
    filterData.edges.map(({ node }) => ({
        ...node,
    }));
